import { IAppState } from '../../../../common/context/context'
import { key, PermutarNeumaticosState } from './permutarNeumaticosReducer'

export const selectPermutarNeumaticos = (
  state: IAppState
): PermutarNeumaticosState => state[key] as PermutarNeumaticosState

export const isPermutarNeumaticosLoading = (state: IAppState): boolean => {
  const acState = selectPermutarNeumaticos(state)
  return acState.loading
}
export const getPermutarNeumaticosStep = (state: IAppState): number => {
  const acState = selectPermutarNeumaticos(state)
  return acState.step
}
